<template lang="pug">
.full-entity
  v-form
    v-tabs(show-arrows, @change="activeTab = $event", v-bind="tabsFinalProps", :slider-size="5")
      v-tab(
        v-for="(relation, tabIndex) in [{...entity, root: true}].concat(relations)",
        :class="{ error: !disregardErrorInTab(tabIndex) && (errorInTab(relation) || formatedErrors(relation).length) }",
        :key="relation.name",
        :to="`#${relation.name}`"
       ) {{ getLabel(relation) }}
      v-tab-item(
        :class="{ 'draft-ribbon': isDraft }",
        :key="(entity.name || '').replace(/_/g, ' ')",
        :value="entity.name"
      )
        slot(
          :name="entity.name",
          :entity="entity",
          :selector="false",
          :chips="false",
          :relation="entity"
          :value="instance",
          :sections="sections.filter(x => x.section === entity.name || x.section === entity.tabLabel)",
        )
          app-entity(
            :entity="entity",
            :selector="false",
            :chips="false",
            :relation="entity",
            :parent="entity",
            :extra-data="false",
            v-bind="{ disabled }",
          )
          template(v-for="section in sections.filter(x => x.section === entity.name || x.section === entity.tabLabel)")
            slot(:name="section.name", :path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", v-bind="{ disabled }")
              app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", :vertical="section.type !== 'BusinessScope'", v-bind="{ disabled }")
      v-tab-item(
        v-for="relation in relations",
        :key="relation.name",
        :value="relation.name"
      )
        app-instance-history(v-if="relation.type === 'IEntityLog'", :instance="instance")
        slot(v-else, :name="relation.name", :path="relation.name", :parent="entity", :parent-instance="instance", :relation="relation", :entity="$findEntity(relation.type)" :isActive="activeTab === relation.name")
          app-entity-relation(:path="relation.name", :parent="entity", :parent-instance="instance", :relation="relation", :entity="getEntityRelation(relation)", :isActive="activeTab === relation.name", v-bind="{ disabled }", :extraLoads="getCustomLoads(relation)", :extraWheres="getCustomWheres(relation)")
          template(v-for="section in sections.filter(x => x.section === relation.name)")
            slot(:name="section.name", :path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", v-bind="{ disabled }")
              app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", :isActive="activeTab === section.section", v-bind="{ disabled }")
</template>

<style lang="scss" scoped>
  .draft-ribbon {
    width: 100%;
    border-top: 8px solid grey;
  }
  .error {
    background-color: red !important;
  }

  .full-entity {
    .v-tab {
      text-transform: capitalize;
    }
  }
</style>

<script>
import EntityMixin from '@/mixins'
export default {
  mixins: [EntityMixin],
  props: {
    isDraft: {
      type: Boolean,
      default: false
    },
    entity: {
      type: Object,
      default: () => ({})
    },
    customLabel: {
      type: Object,
      default: () => ({}),
    },
    tabsWithErrors: {
      type: Array,
      default: () => ([]),
    },
    disregardErrorInTabs: {
      type: Array,
      default: () => ([]),
    },
    disableErrorTabs: {
      type: Boolean,
      default: false,
    },
    tabsProps: {
      type: Object,
      default: () => ({}),
    },
    sectionIgnore: {
      type: Boolean,
      default: false,
    },
    customLoads: {
      type: Object,
      default: () => ({})
    },
    customWheres: {
      type: Object,
      default: () => ({})
    },
  },
  data: function () {
    return {
      activeTab: null,
      tabsDefaultProps: {
        backgroundColor: "grisClair",
        color: "primaryHover",
        dark: false,
      },
      //
    }
  },
  created () {
    this.$store.commit('SET_INSTANCE', { extraData: [], ...this.instance, entityState: this.instance && this.instance.id ? 3 : 4, _Entity: this.entity.name })
    this.$store.commit('SET_ERRORS', { })
  },
  methods: {
    errorInTab({ name }) {
      return this.tabsWithErrors.some(e => e == name);
    },
    disregardErrorInTab(tabindex) {
      return this.disregardErrorInTabs.some(e => e == tabindex);
    },
    formatedErrors(relation) {
      if (this.disableErrorTabs) return []
      return Object.keys(this.$formatErrors(this.$store.state.errors, relation))
    },
    findTabErrors(errors, relation) {
      console.log('evaluating errors', this.$cleanString(errors), this.$cleanString(relation))
      // TODO
      // find fields in relation that has the name of the error
      // return those errors that matches fields in the relation
      return errors
    },
    getLabel(val) {
      var labelAttribute = val.tabLabel || val.name;
      if (!labelAttribute) return '';

      let customLabelObject = this.customLabel;
      //If the customLabel prop is empty and the entity has customLabel property on the projectConfig, use them
      if(_.isEmpty(customLabelObject) && this.$getCustomLabel(this.entity.name)) {
        customLabelObject = this.$getCustomLabel(this.entity.name);
      }

      const getCustomLabel = _.get(customLabelObject, labelAttribute);
      if (getCustomLabel) return getCustomLabel;

      const translationPath = val.root ? '_name' : val.name;
      const entityTranslationPath = `${this.entity.name}.${translationPath}`;
      if (this.$te(entityTranslationPath)) return this.$tc(entityTranslationPath, 1);

      labelAttribute = labelAttribute.replace(/\_[\d]+/, '')
      return this.$camelToString(this.$displayName(labelAttribute));
    },
    getEntityRelation(relation) {
      const { type, extra } = relation;
      if (this.portal && extra) return relation;
      return this.$findEntity(type)
    },
    getCustomLoads(relation) {
      return _.get(this.customLoads, relation.name);
    },
    getCustomWheres(relation) {
      return _.get(this.customWheres, relation.name);
    },
  },
  computed: {
    sections () {
      return this.$fields(this.entity, null, [], [], [], this.sectionIgnore)
        .filter(p => !p.primitive && p.section)
        .filter(f => !this.ignoreTabs.find(iT => f.name === iT));
    },
    tabsFinalProps() {
      return _.assign({}, this.tabsDefaultProps, this.tabsProps);
    },

  },
}
</script>
